<app-common-loader *ngIf="carregandoTarefas"></app-common-loader>

<div class="tarefas-container">
  <header class="page-hero">
    <span class="hero-icon">
      <mat-icon>task_alt</mat-icon>
    </span>
    <div class="hero-texto">
      <h1>
        Minhas tarefas
        @if (tarefas) {
        <span class="hero-badge">{{ totalObras }}</span>
        }
      </h1>
      <p>Acompanhe e gerencie suas tarefas.</p>
    </div>

    <div class="hero-acoes">
      <button
        class="btn-hero btn-hero-excluir"
        type="button"
        *ngIf="!carregandoTarefas && tarefas?.length > 0 && isAllSelected()"
        (click)="abrirModalExcluir()"
      >
        <mat-icon>delete_outline</mat-icon>
        Excluir selecionados
      </button>
      <button class="btn-hero" type="button" (click)="abrirModal()">
        <mat-icon>add</mat-icon>
        Criar tarefa
      </button>
    </div>
  </header>

  <ul class="nav nav-tabs mb-3">
    <li class="nav-item" *ngFor="let status of statusTabs">
      <a
        class="nav-link pb-0"
        [class.active]="statusSelecionado === status.key"
        (click)="mudarAba(status.key)"
        style="cursor: pointer"
      >
        {{ status.label }}
      </a>
    </li>
  </ul>

  <div class="filtros d-flex flex-wrap gap-3">
    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="toggleResponsavel()"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/user.svg"
          />
          {{
            filtroResponsavel === "Todos"
              ? "Todos os responsáveis"
              : nomeResponsavelSelecionado
          }}
        </button>
        <button
          *ngIf="filtroResponsavel !== 'Todos'"
          type="button"
          class="btn-clear"
          (click)="limparResponsavel()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarResponsavel" class="dropdown-list">
        <label>
          <input
            type="radio"
            name="responsavel"
            value="Todos"
            [(ngModel)]="filtroResponsavel"
            (change)="onResponsavelChange()"
          />
          Todos
        </label>
        <label *ngFor="let r of responsavel">
          <input
            type="radio"
            name="responsavel"
            [value]="r.id"
            [(ngModel)]="filtroResponsavel"
            (change)="onResponsavelChange()"
          />
          {{ r?.name }}
        </label>
      </div>
    </div>

    <div class="filtro-periodo-wrapper input-filtro-selecionado">
      <input
        type="text"
        bsDaterangepicker
        [(ngModel)]="intervaloSelecionado"
        [bsConfig]="config"
        (ngModelChange)="onPeriodoChange()"
        class="input-periodo"
        placeholder="Todos os períodos"
        readonly
      />
      <button
        *ngIf="intervaloSelecionado?.length"
        type="button"
        class="btn-clear"
        (click)="limparPeriodo()"
      >
        ×
      </button>
    </div>

    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="toggleTipoObra()"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{
            filtroTipoObraSelecionados.length === 0
              ? "Todos os tipos de obra"
              : filtroTipoObraSelecionados.length + " tipo(s) selecionado(s)"
          }}
        </button>
        <button
          *ngIf="filtroTipoObraSelecionados?.length"
          type="button"
          class="btn-clear"
          (click)="limparTiposObra()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarTipoObra" class="dropdown-list">
        <label *ngFor="let tipo of tiposObra">
          <input
            type="checkbox"
            class="checkbox"
            [checked]="filtrosAtivos.tiposObra.includes(tipo.moduleID)"
            (change)="
              onTipoObraToggle(tipo.moduleID, $event); onTipoObraChange()
            "
          />
          {{ tipo.module }}
        </label>
      </div>
    </div>

    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="toggleTipoTarefa()"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{
            filtroTipoTarefa === "Todos"
              ? "Todos os tipos de tarefa"
              : filtroTipoTarefa
          }}
        </button>
        <button
          *ngIf="filtroTipoTarefa !== 'Todos'"
          type="button"
          class="btn-clear"
          (click)="limparTipoTarefa()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarTipoTarefa" class="dropdown-list">
        <label>
          <input
            type="radio"
            name="tipoTarefa"
            value="Todos"
            [(ngModel)]="filtroTipoTarefa"
            (change)="onTipoTarefaChange()"
          />
          Todos
        </label>
        <label *ngFor="let t of acoes">
          <input
            type="radio"
            name="tipoTarefa"
            [value]="t.description"
            [(ngModel)]="filtroTipoTarefa"
            (change)="onTipoTarefaChange()"
          />
          {{ t.description }}
        </label>
      </div>
    </div>

    <div class="filtro-busca-wrapper input-filtro-selecionado">
      <input
        type="text"
        [(ngModel)]="termoBusca"
        (keydown.enter)="onTermoBuscaChange()"
        class="input-busca"
        placeholder="Buscar por obra"
      />
      <img
        src="{{
          BASE_IMG_URL
        }}assets/header/icon-search-label.png"
        alt=""
        width="20"
        height="20"
        class="input-icon"
      />
      <button
        *ngIf="termoBusca"
        type="button"
        class="btn-clear"
        aria-label="Limpar busca"
        (click)="limparBusca()"
      >
        ×
      </button>
    </div>
  </div>

  <div
    *ngIf="tarefas && tarefas.length === 0 && !carregandoTarefas"
    class="no-results-container"
  >
    <div class="no-results">
      <p>Nenhuma tarefa encontrada!</p>
      <button class="btn btn-primary" type="button" (click)="abrirModal()">
        Criar nova tarefa
      </button>
    </div>
  </div>

  <table
    *ngIf="tarefas && tarefas.length > 0"
    class="table table-hover align-middle table-scroll"
  >
    <thead class="head-table">
      <tr class="title">
        <th class="title-table">
          <input
            type="checkbox"
            class="checkbox"
            (change)="selecionarTodosTarefas($event)"
            [checked]="isAllSelected()"
          />
        </th>
        <th
          class="title-table"
          (click)="ordenarPorCampo('followUpDate')"
          style="cursor: pointer"
        >
          Data
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th
          class="title-table"
          (click)="ordenarPorCampo('companyName')"
          style="cursor: pointer"
        >
          Empresa
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th
          class="title-table"
          (click)="ordenarPorCampo('workName')"
          style="cursor: pointer"
        >
          Obra
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th
          class="title-table"
          (click)="ordenarPorCampo('workType')"
          style="cursor: pointer"
        >
          Tipo de Obra
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th
          class="title-table"
          (click)="ordenarPorCampo('actionDescription')"
          style="cursor: pointer"
        >
          Ação
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th
          class="title-table"
          (click)="ordenarPorCampo('responsibleName')"
          style="cursor: pointer"
        >
          Responsável
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th class="title-table">Contato</th>
        <th
          class="title-table"
          (click)="ordenarPorStatus()"
          style="cursor: pointer"
        >
          Status
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="23"
            height="23"
          />
        </th>
        <th class="title-table">Anotação</th>
        <th class="title-table">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of tarefas; trackBy: trackByTaskId">
        <td>
          <input
            type="checkbox"
            [(ngModel)]="t.selecionada"
            (change)="onTarefaSelecionada(t)"
            class="checkbox"
          />
        </td>
        <td>{{ t.followUpDate | date : "dd/MM/yyyy HH:mm" }}</td>

    
        <td class="table-link" [title]="t.companyName">
          <a href="#" (click)="$event.preventDefault(); onEmpresaClick(t)">
            <strong>
              {{
                t.companyName?.length > 32
                  ? (t.companyName | slice : 0 : 32) + "..."
                  : t.companyName
              }}
            </strong>
          </a>
        </td>
      
        <td class="table-link" [title]="t.workName">
          <a (click)="abrirObra(t)" [title]="t.workName">
            <strong>
              {{
                t.workName.length > 32
                  ? (t?.workName | slice : 0 : 32) + "..."
                  : t?.workName
              }}
            </strong>
          </a>
        </td>

    
        <td>
          <span
            class="tag"
            [ngClass]="getTagClass(t.workType)"
            [style.background]="getTipoObraColor(t.workType)"
            >{{ t?.workType }}</span
          >
        </td>
        <td class="acao">
          <strong>{{ t?.actionDescription }}</strong>
        </td>
        <td>{{ t.responsibleName }}</td>
        <td>
          <div>
            <strong class="contact-name">{{ t.contactName }}</strong
            ><br />
            <small>{{ t?.contactRole }}</small
            ><br />
            <a
              class="contato-email"
              *ngIf="t.contactEmail"
              [href]="'mailto:' + t.contactEmail"
              [title]="t.contactEmail"
              >{{ t?.contactEmail | truncate : 25 }}</a
            ><br />
            {{ t?.contactPhone }}
          </div>
        </td>
        <td>
          <span class="status" [ngClass]="getStatusClass(t.statusDescription)">
            {{ t?.statusDescription }}
          </span>
        </td>

        <td class="table-link" [title]="t.description || 'Sem anotação'">
          <strong>
            {{
              (t.description?.length > 32
                ? (t.description | slice : 0 : 32) + "..."
                : t.description) || "Sem anotação"
            }}
          </strong>
        </td>
        <td>
          <div class="d-flex gap-2 btn-acoes-lista">
            <button
              type="button"
              class="btn-excluir-tarefa"
              title="Excluir tarefa"
              (click)="abrirModalExcluir(t.taskID)"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/delete.svg"
                width="20"
                height="20"
                alt=""
              />
            </button>

            <button
              type="button"
              class="btn-concluir-tarefa"
              title="Concluir tarefa"
              (click)="abrirModalConcluirTarefa(t)"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/check.svg"
                width="20"
                height="20"
                alt=""
              />
            </button>
            <button
              type="button"
              title="Editar tarefa"
              (click)="abrirModalEditarTarefa(t)"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/edit.svg"
                width="20"
                height="20"
                alt=""
              />
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <small class="exibe-pag" *ngIf="tarefas?.length > 0">
    Exibindo {{ tarefas?.length }} de {{ totalObras }} tarefas
  </small>

  @if (this.tarefasFiltradas.length >= 25 || this.totalObras >= 25) {
  <div class="d-flex justify-content-center align-items-center mt-3">
    <app-paginacao-tarefas
      [paginacao]="{
        page: currentPage,
        pageFirst: 1,
        pageLast: totalPages,
        pageNext: currentPage < totalPages ? currentPage + 1 : null,
        pagePrev: currentPage > 1 ? currentPage - 1 : null,
        recordsCount: tarefasFiltradas.length,
        pageActive: true,
        pageSize: 10,
        shortcuts: 0,
        hasValue: tarefasFiltradas.length > 0,
        shortcutPages: [],
        records: tarefasFiltradas
      }"
      (paginaMudada)="mudarPagina($event)"
    ></app-paginacao-tarefas>
  </div>
  }

  <app-concluir-tarefa
    *ngIf="mostrarModalConcluir"
    [taskID]="taskID"
    (tarefaConcluida)="onTarefaConcluida()"
    (fecharDialogo)="fecharModalConcluirTarefa($event)"
  >
  </app-concluir-tarefa>

  <app-excluir-tarefas
    [taskID]="taskID"
    [selectedTaskIds]="selectedTaskIds"
    *ngIf="mostrarModalExcluir"
    (fecharDialogo)="fecharModalExcluir($event)"
    (loading)="carregandoTarefas = $event"
  ></app-excluir-tarefas>
  <app-editar-tarefa-criada
    *ngIf="mostrarModalEditar"
    [tarefaSelecionada]="tarefaSelecionada"
    (fecharDialogo)="fecharModalEditarTarefa()"
    (tarefaEditada)="carregarTarefas()"
  ></app-editar-tarefa-criada>
</div>
